export default __webpack_public_path__ + "static/media/LVT.69554b66.png";